import React from "react";
import { Grid, Hidden } from "@material-ui/core";
import FullImage from "./FullImage";
import CreateCampaignButton from "./CreateCampaignButton";
import { openPopupWidget } from "react-calendly";

import { makeStyles } from "@material-ui/core/styles";

import HomeButton from './HomeButton';

const cellphone = process.env.PUBLIC_URL + "/home_page/img_cold_calls.png";
const coldCallsBack = process.env.PUBLIC_URL + "/home_page/img_cold_calls_back.png";

const styles: any = {
  flexBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  customButton: {
    color: '#FFFFFF',
    fontSize: '20px',
    fontWeight: '600',
    letterSpacing: 0,
    lineHeight: '23px',
    textAlign: 'center',
    height: '50px',
    width: '240px',
    borderRadius: '4px',
    backgroundColor: '#00ABCA',
    fontFamily: 'Asap',
    border: 'none',
    cursor: 'pointer'
  }
};

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${coldCallsBack})`,
    backgroundSize: '100% 100%',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    padding: "80px 100px",
    maxWidth: 1100,
    [theme.breakpoints.down("md")]: {
      padding: 30,
    },
    
  },
  textContainer: {
    [theme.breakpoints.down("sm")]: {
      padding: "0 25px",
    },
  },
  title: {
    color: "#FFF",
    fontFamily: "Roboto",
    fontSize: "44px",
    paddingRight: 30,
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      paddingRight: 0,
      fontSize: "22px",
    },
  },
  titleSmall: {
    color: "#FFF",
    fontFamily: "Roboto",
    fontSize: 18,
    paddingRight: 30,
    [theme.breakpoints.down("md")]: {
      paddingRight: 0,
      fontSize: 14,
    },
  },
  subTitle: {
    color: "#FFF",
    fontFamily: "Roboto",
    fontSize: 18,
    letterSpacing: 0,
    // paddingTop: 40,
    paddingBottom: 40,
    [theme.breakpoints.down("md")]: {
      paddingRight: 0,
      fontSize: 14,
    },
  },
  listItems: {
    fontSize: "18px",
    color: "#FFF",
    fontFamily: "Roboto",
    lineHeight: 1.5,
  },
  buttonContainer: {
    [theme.breakpoints.down("sm")]: {
      display: 'flex',
      justifyContent: 'center'
    },
  }
}));

const CustomButton = () => {
  const url = 'https://calendly.com/jay-004';
  const prefill = {};
  const pageSettings = {};
  const utm = {};

  const onClick = () => openPopupWidget({ url, prefill, pageSettings, utm });

  return <button onClick={onClick} style={styles.customButton}>Request Demo</button>;
};

interface TopSectionProps {
  onClick(action: string, route: string): void;
}

export default React.memo((props: TopSectionProps) => {
  const classes = useStyles({});
  return (
    <div className={classes.mainContainer}>
      <Grid className={classes.container} container>
        <Grid item xs={12} md={6} sm={12} style={styles.flexBox}>
          <div className={classes.textContainer}>
            <div className={classes.title} style={{}}>
              The Modern Day Call Center
              <div className={classes.titleSmall}>You don't have to cold call anymore</div>
              <ul className={classes.listItems}>
                <li>Compliant out-bound calls</li>
                <li>Compliant text campaigns</li>
                <li>You Upload, we deliver</li>
              </ul>
            </div>
            <div className={classes.subTitle}>
              All records are scrubbed against the National Do Not Call list and
              sent by hand.
            </div>
            <div className={classes.buttonContainer}>
              <HomeButton text="Get started" onClick={() => props.onClick('signup', '')} />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} sm={12} style={styles.flexBox}>
          <FullImage src={cellphone} />
        </Grid>
      </Grid>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/pages/home/components/TopSection.tsx